import React, { Component } from 'react'
import axios from 'axios'

import {
  Text,
  TextAppearance,
  Layout,
  LayoutRowGap,
  Breakpoints
} from '@volkswagen-onehub/components-core'

import { ChevronDown } from '@volkswagen-onehub/icons-core'
import { getKey } from '../../../utils'

import {
  Container,
  IconContainer,
  ErrorContainer,
  LabelContainer
} from './mHTMLSelect.style'

import { VALID, INVALID } from 'form/store/form/constants'

class HTMLSelect extends Component {
  constructor(props) {
    super(props)
    this.state = { options: [] }
  }

  optionsChanged = event => {
    const { cmsData, setFormElement } = this.props
    const selectedIndex = this.refs.dropdown.selectedIndex

    setFormElement(cmsData.name, {
      value: cmsData.options[selectedIndex].value,
      valid: cmsData.options[selectedIndex].value === '-1' ? INVALID : VALID
    })
  }

  componentDidMount() {
    const { cmsData } = this.props
    if (cmsData.loadInOptions && cmsData.loadInOptions !== '') {
      axios({
        method: 'get',
        url: cmsData.loadInOptions,
        responseType: 'stream'
      })
        .then(response => {
          const list = response.data[cmsData.loadInResponseObj]
          const loadedInList = list.map(item => {
            const prop = item[cmsData.loadInResponseProperty]
            return { label: prop, value: prop }
          })
          loadedInList.unshift(cmsData.options[0])
          this.setState({ options: loadedInList })
          cmsData.options = loadedInList
        })
        .catch(error => {
          this.setState({ options: cmsData.options })
        })
    } else {
      this.setState({ options: cmsData.options })
    }
  }

  render() {
    const { cmsData, selectedValue, getInputStyle } = this.props
    const { options } = this.state

    return (
      <Layout
        rowGap={LayoutRowGap.static300}
        appearance={{
          [Breakpoints.default]: [{ name: 'a', columns: 24 }],
          [Breakpoints.b960]: [
            { name: 'a', columns: 12 },
            { name: '.', columns: 12 }
          ]
        }}
      >
        {cmsData.label !== '' && (
          <LabelContainer className={getInputStyle === 2 ? 'reduce' : ''}>
            <Text tag="p" appearance={TextAppearance.copy100}>
              {cmsData.label}
            </Text>
          </LabelContainer>
        )}
        {getInputStyle === 2 && (
          <ErrorContainer>
            <Text tag="p" appearance={TextAppearance.copy100}>
              {cmsData.error}
            </Text>
          </ErrorContainer>
        )}
        <Container className="select-container">
          <IconContainer>
            <ChevronDown />
          </IconContainer>
          <select
            ref="dropdown"
            onChange={this.optionsChanged}
            value={selectedValue}
          >
            {options &&
              options.map((item, index) => {
                return (
                  <option key={getKey()} value={item.value}>
                    {item.label}
                  </option>
                )
              })}
          </select>
        </Container>
      </Layout>
    )
  }
}

export default HTMLSelect
